import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { processRefundOrder } from '../../../../../actions/tools/DecisionTree/OrderActions';

const DTSendMacroAndRefundItemsNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processRefundOrder());

  return (
    <DTCopyTextSendMacroView
      buttonText={'REFUND'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={'You are about to refund the items for this order and copy the response to the text box'}
    />
  );
};

export default withConfirmation(DTSendMacroAndRefundItemsNode);
